import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/loaders";
import { actions } from "../../../../../reducers/cadastro/roteiros.actions";
import { getPayload } from "../../../../../selectors/routes.selectors";
import { getAlertas } from "../../../../../selectors/cadastro/roteiros.selectors";
import AlertsTable from "./AlertsTable";

const AlertsTableConnected = () => {
  const { data, loading } = useSelector(getAlertas);
  const { idRoteiro } = useSelector(getPayload);
  const { resultado: items, total, paginaAtual } = data;

  const dispatch = useDispatch();

  const handlePagination = (e, page) => {
    dispatch(
      dispatch(
        actions.obterAlertas.request({ pagina: page, limite: 9, idRoteiro })
      )
    );
  };

  if (loading) {
    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <Loader />
      </div>
    );
  }

  return (
    <AlertsTable
      data={items}
      handlePagination={handlePagination}
      pageSize={9}
      total={total}
      paginaAtual={paginaAtual}
    />
  );
};

export default AlertsTableConnected;
